import iconThemeColor from "../index";

const EditIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9393 4.35355C16.5251 3.76777 17.4749 3.76777 18.0607 4.35356L19.6464 5.93934C20.2322 6.52513 20.2322 7.47488 19.6464 8.06066L9.43702 18.2701C9.32724 18.3799 9.19342 18.4626 9.04614 18.5117L6.55548 19.3419C5.38284 19.7328 4.26723 18.6172 4.65811 17.4445L5.48833 14.9539C5.53743 14.8066 5.62013 14.6728 5.72991 14.563L15.9393 4.35355ZM17.3536 5.06066C17.1583 4.8654 16.8417 4.8654 16.6464 5.06066L15.7071 6L18 8.29289L18.9393 7.35356C19.1346 7.15829 19.1346 6.84171 18.9393 6.64645L17.3536 5.06066ZM17.2929 9L15 6.70711L6.43702 15.2701L5.6068 17.7607C5.4765 18.1516 5.84837 18.5235 6.23925 18.3932L8.72991 17.563L17.2929 9Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedEditIcon = iconThemeColor(EditIcon);
